"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMultiStyleConfig, Box, Text, useDisclosure, useBreakpointValue, forwardRef, } from "@chakra-ui/react";
import { PassiveVariants, InteractiveVariants, SubheaderVariants, } from "./Notification.types";
import { Button, Link } from "../../atoms";
import { IconButton } from "../../atoms/IconButton";
import { SvgSpriteConsumer } from "../../atoms/SvgSprite";
function getDeleteSize(variant) {
    if (Object.values(PassiveVariants).includes(variant)) {
        return 24;
    }
    return 16;
}
function getIconId(variant) {
    switch (variant) {
        case InteractiveVariants.INTERACTIVE_ERROR:
        case PassiveVariants.PASSIVE_ERROR:
            return "alert24";
        case InteractiveVariants.INTERACTIVE_SUCCESS:
        case PassiveVariants.PASSIVE_SUCCESS:
            return "checkCircle24";
        case InteractiveVariants.INTERACTIVE_WARNING:
        case PassiveVariants.PASSIVE_WARNING:
            return "warning24";
        case InteractiveVariants.INTERACTIVE_INFORMATION:
        case PassiveVariants.PASSIVE_INFORMATION:
        default:
            return "info24";
    }
}
function getCloseIconColor(variant) {
    switch (variant) {
        case InteractiveVariants.INTERACTIVE_ERROR:
        case PassiveVariants.PASSIVE_ERROR:
        case SubheaderVariants.SUBHEADER_ERROR:
            return "semantic.icon.error";
        case InteractiveVariants.INTERACTIVE_SUCCESS:
        case PassiveVariants.PASSIVE_SUCCESS:
        case SubheaderVariants.SUBHEADER_SUCCESS:
            return "semantic.icon.success";
        case InteractiveVariants.INTERACTIVE_WARNING:
        case PassiveVariants.PASSIVE_WARNING:
            return "semantic.icon.warning";
        case InteractiveVariants.INTERACTIVE_INFORMATION:
        case PassiveVariants.PASSIVE_INFORMATION:
        default:
            return "semantic.icon.info";
    }
}
function isSubHeader(variant) {
    return Object.values(SubheaderVariants).includes(variant);
}
const Notification = forwardRef(({ linkProps, buttonProps, title, description, badge, variant = PassiveVariants.PASSIVE_INFORMATION, isClosable = true, onClose, closeLabel = "close", withBorder, withoutShadow, withoutLeftIcon, }, ref) => {
    const size = useBreakpointValue({
        base: "desktop",
        sm: "mobile",
        md: "desktop",
    }, {
        fallback: "md",
    });
    const styles = useMultiStyleConfig("Notification", {
        variant,
        size,
    });
    const { isOpen, onClose: disclosureClose } = useDisclosure({
        defaultIsOpen: true,
    });
    return isOpen ? (_jsxs(Box, Object.assign({ ref: ref, sx: Object.assign(Object.assign(Object.assign({}, styles.mainContainer), (typeof withBorder !== "undefined"
            ? { borderWidth: withBorder ? "1px" : 0 }
            : {})), (!withoutShadow && !isSubHeader(variant)
            ? { boxShadow: "large" }
            : {})) }, { children: [!withoutLeftIcon && !isSubHeader(variant) ? (_jsx(Box, Object.assign({ sx: styles.leftIcon }, { children: _jsx(SvgSpriteConsumer, { svgId: getIconId(variant), size: 24 }) }))) : null, _jsxs(Box, Object.assign({ sx: styles.textsAndActionsContainer }, { children: [_jsxs(Box, Object.assign({ sx: styles.textsContainer }, { children: [title ? (_jsx(Text, Object.assign({ sx: styles.title, as: "h2" }, { children: title }))) : null, description ? (_jsx(Text, Object.assign({ sx: styles.description }, { children: description }))) : null] })), buttonProps || linkProps ? (_jsxs(Box, Object.assign({ sx: styles.actionsContainer }, { children: [linkProps ? _jsx(Link, Object.assign({}, linkProps)) : null, buttonProps ? (_jsx(Button, Object.assign({ size: "sm", variant: "secondaryOutlined" }, buttonProps))) : null] }))) : null] })), isClosable || badge ? (_jsxs(Box, Object.assign({ sx: styles.closeAndBadgeContainer }, { children: [isClosable ? (_jsx(IconButton, Object.assign({ variant: "notificationDeleteIcon", minWidth: "unset", width: `${getDeleteSize(variant)}px`, height: `${getDeleteSize(variant)}px`, color: getCloseIconColor(variant), "aria-label": closeLabel, lang: "en", onClick: (e) => {
                            if (onClose) {
                                onClose(e);
                            }
                            else {
                                disclosureClose();
                            }
                        }, icon: _jsx(SvgSpriteConsumer, { svgId: `delete${getDeleteSize(variant)}`, size: getDeleteSize(variant) }) }, { children: "close" }))) : null, badge ? _jsx(Box, Object.assign({ sx: styles.badge }, { children: badge })) : null] }))) : null] }))) : null;
});
Notification.displayName = "Notification";
export default Notification;
//# sourceMappingURL=Notification.js.map